import { Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BcAlertComponent } from '@bancolombia/design-system-web/bc-alert';
import { BcDialogService } from '@bancolombia/design-system-web/bc-services';
import { URLRedirect } from 'src/app/core/constants/URLRedirect';
import { CacheService } from 'src/app/core/services/shared/cache.service';


@Component({
  selector: 'app-policy-finish',
  templateUrl: './policy-finish.component.html',
  styleUrls: ['./policy-finish.component.css']
})
export class PolicyFinishComponent implements OnInit {
  exitRedirect: string = URLRedirect.exitRedirect
  showError: boolean = false

  topImage: string = "210px";

  userMail: string;

  dateSign: Date = new Date();

  @Input()
  success: boolean = false

  @Input()
  auth: boolean = false

  @Input()
  textModal: string = "Código 0000"

  @Input()
  titleModal: string = "Mensaje de notificación para código incorrecto"

  @Input()
  screenTime: number = 2000

  @Input()
  exitMessage: string = "Salir"

  policy = null

  @Output()
  retryEmit = new EventEmitter();

  constructor(
    private router: Router,
    private dialogService: BcDialogService,
    private ngZone: NgZone,
    private _cacheService: CacheService
  ) { }

  ngOnInit(): void {
    this.disabledBack();
    if (this.screenTime > 0) {
      this.showScreenError();
    } else {
      this.topImage = "50px"
    }
    this.userMail = this._cacheService.get("emailClient")
    this.policy = this._cacheService.get('policy') || { insurance: 'Plan protege tu vida', month_value: 30800 }
    this.dateSign = new Date();
  }

  open(): void {
    this.dialogService.open(BcAlertComponent, {
      type: "error",
      text: this.textModal,
      title: this.titleModal,
      dismissible: true,
      timeout: 5000,
    });
  }

  signOtherPolicy() {
    if (this.success) {
      this.router.navigateByUrl('policy')
    }
  }

  disabledBack() {
    this.ngZone.runOutsideAngular(() => {
      const documentTitle = document.title
      const locationHref = location.href
      history.pushState(null, documentTitle, locationHref);
      this.router.events.subscribe((event: NavigationStart) => {
        if (event.navigationTrigger === "popstate" && this.success) {
          history.pushState(null, documentTitle, locationHref);
          this.router.navigateByUrl('policy')
        }
      });
    });
  }

  showScreenError() {
    const secondsTime = this.screenTime;
    if (!this.success) {
      this.topImage = "50px"
      this.showError = true
      setTimeout(() => {
        this.showError = false
        this.open()
      }, secondsTime);
    }
  }

  retry() {
    if (this.auth) {
      this.router.navigateByUrl("/auth");
    } else {
      this.retryEmit.emit()
    }
  }

  buttonBack() {
    this.router.navigateByUrl('policy')
  }
}

